import { render, staticRenderFns } from "./SHHistoryCardSkeleton.vue?vue&type=template&id=06847d68&"
import script from "./SHHistoryCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SHHistoryCardSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports